import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Home as HomeIcon } from "lucide-react";

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center px-5 text-center">
      <p className="font-serif text-7xl text-champagne-gold">404</p>
      <h1 className="mt-4 font-serif text-3xl text-deep-ink">Page not found</h1>
      <Link
        to="/"
        className="mt-8 inline-flex items-center gap-2 rounded-full bg-deep-ink px-6 py-3 text-warm-ivory transition-colors hover:bg-champagne-gold hover:text-deep-ink"
      >
        <HomeIcon className="h-4 w-4" />
        {t("nav.home")}
      </Link>
    </div>
  );
}
